import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { LocalStorageService } from '../shared/local-storage.service';
import { ToastrService } from 'ngx-toastr';

enum GroundfishGearType { Pot = "Pot", Longline = "Longline", Pelagic = "Pelagic" };
enum HMSGearType { Harpoon = "Harpoon", GillNetDrift = "Rod and Reel", TrollLine = "Troll Line", Pole = "Pole", DSBG = "Deep Set Buoy Gear" };
enum DSBGSubType { Standard = "Standard", Linked = "Linked", StandardNight = "Standard-Night", LinkedNight = "Linked-Night" };
enum Fishery { Groundfish = "Groundfish", HMS = "HMS"};

/**
 * One of the three gear types is selected here.
 * This is displayed as a sub-component of the gear-select-dialog component
 */
@Component({
    selector: 'app-gear-type-dialog',
    templateUrl: './gear-type-dialog.component.html',
    styleUrls: ['./gear-type-dialog.component.css'],
    standalone: false
})
export class GearTypeDialogComponent implements OnInit {

  // gear name (doesn't save when going back to gear type screen)
  @Input() gearName: string = "";
  typeForm: UntypedFormGroup = new UntypedFormGroup({
    name: new FormControl<string>(this.gearName)
  });
  currGearName: string = this.typeForm.value.name;

  /**
   * Fishery type 
   */
  @Input() selectedFishery: Fishery = Fishery.Groundfish;

  /**
   * If going back to gear type, remember what gear selected was
   */ 
  @Input() selectedGFType: GroundfishGearType = GroundfishGearType.Pot;
  
  /**
   * If going back to gear type, remember what gear selected was
   */ 
  @Input() selectedHMSType: HMSGearType = HMSGearType.Harpoon;

  selectedDSBGType: DSBGSubType = DSBGSubType.Standard;

  @Input() setFishery: string = ''

  /**
   * Change screen to list, settings, or gear form
   */ 
  @Output() changeScreen: EventEmitter<{ name: string, screen: string, hmsType: string, dsbgSubType: string }> = new EventEmitter<{ name: string, screen: string, hmsType: string, dsbgSubType: string }>();

  /**
   * Back to list or settings screen
   */ 
  @Output() goBack: EventEmitter<any> = new EventEmitter<any>();

  constructor(private toastr: ToastrService) {}


  ngOnInit(): void {
    if (this.setFishery != '') this.selectedFishery = this.setFishery == 'Groundfish' ? Fishery.Groundfish : Fishery.HMS;
  }

  // back to gear list or close dialog
  cancel(): void {
    this.goBack.emit();
  }

  /**
   * Check if entered gear name is already a gear name
   */ 
  sameName(): boolean {
    this.currGearName = this.typeForm.value.name ? this.typeForm.value.name : "";
    if (LocalStorageService.user_gear.some(gear => gear.identifier == this.currGearName)) {
      this.toastr.error(this.currGearName + " is already a gear name");
      return true;
    }

    return false;
  }

  /**
   * Go to pot, longline or pelagic form by emitting via the changeScreen data member.
   * Change received by gear-select-dialog which changes to detail screen for corresponding geay type.
   */ 
  goToGearForm(): void {

    if (!this.sameName()) {
      if (this.selectedFishery == Fishery.HMS)
        this.changeScreen.emit({ name: this.currGearName, screen: "Close", hmsType: this.selectedHMSType, dsbgSubType: this.selectedDSBGType });
      else  
        this.changeScreen.emit({ name: this.currGearName, screen: "Detail-" + this.selectedGFType, hmsType: '', dsbgSubType: '' })
    }
  }

}
